import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { Modal, Button, Container, Row, Col, Badge, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { BsCalendarMinusFill, BsExclamationCircleFill, BsPlusLg, BsX } from "react-icons/bs";
import { FaBus, FaMapMarkerAlt  } from 'react-icons/fa';
import style from "../Modal.module.scss";
import "../../../pages/DataCollection/style.css";
import { TODIS_FORM_DSC, TODIS_FORM_FIELD, TODIS_FORM_LIST, TODIS_FORM_LIST_EUAcquis } from "../../Forms";
import { Form, Formik } from "formik";
import { MdDelete, MdLock } from "react-icons/md";
import { ROLE, TODIS_ROLES } from "../../../.config/modals";
import { OrganizationsService } from "../../../HttpService/OrganizationService";
import { LOADING } from "../../Loading/Loading";

const MODAL_ROLE = forwardRef(({refreshRoles, titleFormRole, ...restProps}, ref) => {
    
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    const roleInit = ROLE;

    const [roleId,setRoleId] = useState(0)
    const initialState = "create"
    const [loading, setLoading] = useState(false)
    const [typeAction, setTypeAction] = useState(initialState)
    const [initValue, setInitValue] = useState(roleInit)
    const [dataAccess, setDataAccess] = useState([])
    const [transportT, setTransportT] = useState([])
    const [initDataAccess, setInitDataAccess] = useState([])
    const [initTransportT, setInitTransportT] = useState([])


    const onCreate = async (values) => {

        //console.log("creating role ",values);
        let formIds = [];
        values.permissions.forEach((access) => {access.transportsType.forEach((transportType) => {transportType.permissions.forEach((type) => {formIds.push(type.id)})})})
        formIds = formIds.filter((item,
            index) => formIds.indexOf(item) === index);
        let request = values.permissions.map((item) => { return { id:item.id, formIds}});
        //console.log("role final results", request);
        delete values.permissions;
        values.roleDataAccesses = request;
        setLoading(true)
        try {
            //console.log("Values: ", values)
            const res = await new OrganizationsService("role/add").createUser(values);
            if (res.status == 201) {
                setLoading(false)
                refreshRoles()
                onClose()
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Successfully created Role',
                    showConfirmButton: false,
                    timer: 1500
                    })
            } else {
                console.log("error in create Role", res);
            }
        } catch (error) {
            console.log("error in create Role", error);
        }
    }

    const onUpdate = async (values) => {   
        let formIds = [];
        values.permissions.forEach((access) => {access.transportsType.forEach((transportType) => {transportType.permissions.forEach((type) => {formIds.push(type.id)})})})
        formIds = formIds.filter((item,
            index) => formIds.indexOf(item) === index);
        //console.log("formIds: ", formIds);
        let request = values.permissions.map((item) => { return { id:item.id, formIds}});
        //console.log("request: ", request);
        delete values.permissions;
        values.roleDataAccesses = request;
        //console.log("pre values: ", values);
        setLoading(true) 
        try {
            //console.log("values: ", values);
            ///console.log("ID: ", id)
            const res = await new OrganizationsService("role/update/" + roleId).updateUser(values);
            if (res.status == 201) {
                setLoading(false)
                refreshRoles()
                onClose()
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Successfully updated Role',
                    showConfirmButton: false,
                    timer: 1500
                    })
            } else {
                console.log("error in update Role", res);
            }
        } catch (error) {
            console.log("error in update Role", error);
        }
    }

    const toggleSelection = (itemId) => {
        setDataAccess((prevItems) =>
        prevItems.map((item) => {
          if (item.id === itemId) {
            return { ...item, status: !item.status };
          }
          return item;
        })
      );
    }
    
        const toggleSelectionAllT = (itemId) => {
            const newValue = transportT.map((item) => {
                if(item.id == itemId){
                    const typeForms = item.permissions.map((itm) => {
                        //console.log("itm: ", itm);
                        return { ...itm, status: !item.status };
                    });
                    return {...item, permissions: typeForms, status: typeForms.some(item => item.status)}
                }else{
                    return item;
                }
            })
            setTransportT(newValue);
        }

        const toggleSelectionT = (typeT, value) => {
            const newValue = transportT.map((item) => {
                if(item.id == typeT.id){
                    const typeForms = item.permissions.map((itm) => {
                        if (itm.id === value.id) {
                            return { ...itm, status: !itm.status };
                        }
                        return itm;
                    });
    
                    return {...item, permissions: typeForms, status: typeForms.some(item => item.status)}
                }else{
                    return item;
                }
            })
            setTransportT(newValue);
        }

        const toggleSelectionAllTView = (itemIds) => {
            setTransportT((prevTransportT) => {
                const updatedTransportT = prevTransportT.map((item) => {
                    const typeForms = item.permissions.map((itm) => {
                        if (itemIds.some(({ permissionId, associatedId }) => permissionId == item.id && associatedId == itm.id)) {
                            return { ...itm, status: !itm.status };
                        } else {
                            return itm;
                        }
                    });
                    return { ...item, permissions: typeForms, status: typeForms.some((item) => item.status) };
                });
                return updatedTransportT;
            });
        };
        
        
/*
    const toggleSelectionT = (typeT, value) => {
        console.log("ToggleSelectionT-typeT: ", typeT)
        console.log("ToggleSelectionT-value: ", value)
        const newValue = transportT.map((item) => {
            if(item.id == typeT.id){
                const typeForms = item.permissions.map((itm) => {
                    if (itm.id === value.id) {
                        return { ...itm, status: !itm.status };
                    }
                    return itm;
                });

                return {...item, permissions: typeForms, status: typeForms.some(item => item.status)}
            }else{
                return item;
            }
        })

        setTransportT(newValue);
    }
*/
const selectAllT = (e) => {
    const newValue = transportT.map((item) => {
        if (item.id !== 0) {
            const typeForms = item.permissions.map((itm) => {
                return { ...itm, status: e.target.checked };
            });
            return { ...item, permissions: typeForms, status: e.target.checked };
        } else {
            return item;
        }
    });
    setTransportT(newValue);
};

    
    const selectAll = (e) => {
        setDataAccess((prevItems) => 
            prevItems.map((item) => 
                {
                    return { ...item, status: e.target.checked}
                }
            )
        )
    } 
    
        const applyAccessInfo = (valuesForm, setFieldValue) => {
        let transports = transportT.filter(item => item.status)
        let access = dataAccess.filter(item => item.status)
        if(transports.length == 0 || access.length == 0){
            if(transports.length == 0){
                Toast.fire({
                    icon: 'warning',
                    title: "Select a type of Transport"
                })
            }
            
            if(access.length == 0){
                Toast.fire({
                    icon: 'warning',
                    title: "Select a data Access"
                })
            }
        }else{
            access.map(access => {
                transports.map(transport => {
                    let typeTrans = transport.permissions.filter(item => item.status);
                    typeTrans.map(type => {
                            const newValue = valuesForm.permissions;
                            let status = newValue.some(item => item.id == access.id);
                            let statusTransport = newValue.some(item => item.id == access.id && item.transportsType.some(transp => transp.id == transport.id))
                            let statusPermission = newValue.some(item => item.id == access.id && item.transportsType.find(transp => transp.id == transport.id)?.permissions.some(permission => permission.id == type.id))

                            if(!status || !statusTransport || !statusPermission){
                                if(!status){
                                    newValue.push({id: access.id, name: access.name, transportsType: [{id: transport.id, name: transport.name, permissions: [{id: type.id, name: type.name}]}]})
                                }else if(!statusTransport){
                                    newValue.find(item => item.id == access.id).transportsType.push({id: transport.id, name: transport.name, permissions: [{id: type.id, name: type.name}]})
                                }else{
                                    newValue.find(item => item.id == access.id).transportsType.find(transp => transp.id == transport.id).permissions.push({id: type.id, name: type.name})
                                }
                            }
                            setFieldValue("permissions", newValue)
                    })
                })
            })
        }
    }

    const removeFilter = (valuesForm, actionId, transpValue, permissionValue, setFieldValue) => {
        const newValue = []
        valuesForm.permissions.forEach((item) => {
            if(item.id == actionId){
                const list = [];
                item.transportsType.forEach((itm) => {
                    if (itm.id === transpValue) {
                        const permissions = itm.permissions.filter((permission) => {return permission.id != permissionValue});
                        if(permissions.length > 0)
                            list.push({...itm, permissions: permissions})
                    }else{
                        list.push(itm);
                    }
                });
                if(list.length > 0)
                    newValue.push({...item, transportsType: list});
            }else{
                newValue.push(item);
            }
        })
        setFieldValue("permissions", newValue)
    }

    const getPermissions = async() => {
        try {
            let res = await new OrganizationsService("role/permissions").getDataOrganizations();
            if (res) {
                // const transType = res.rolePermissions.find(item => item.name == "TRANSPORT TYPE").permissions;
                // const access = res.rolePermissions.find(item => item.name == "DATA ACCESS").permissions;
                const transType = res[0].permissions;
                const access = res;
                setInitDataAccess(access)
                setInitTransportT(transType)
                setDataAccess(access)
                setTransportT(transType)
            }
        } catch (error) {
            console.log("error listing organizations", error);
        }
    }

    const detailRole = async (id, typeAction) => {
        setLoading(true)
        try {
            // const res = await new OrganizationsService("user/users/" + id).getDetailsUser();
            // if(res){
            //     setLoading(false)
            //     setInitValue(res)
            //     setTypeAction(typeAction)
            // }
            setRoleId(id)
            let res = await new OrganizationsService("role/roles/" + id).get();

            const formatPermissions = (permissionsData) => {
                const formattedPermissions = permissionsData.map((permission) => {
                  const filteredTransportTypes = permission.permissions.filter((transportType) => transportType.status === true);
                  const formattedTransportTypes = filteredTransportTypes.map((transportType) => {
                    const filteredSubPermissions = transportType.permissions.filter((subPermission) => subPermission.status === true);
                    const formattedSubPermissions = filteredSubPermissions.map((subPermission) => ({
                      id: subPermission.id,
                      name: subPermission.name
                    }));
              
                    return {
                      id: transportType.id,
                      name: transportType.name,
                      permissions: formattedSubPermissions
                    };
                  });
              
                  return {
                    id: permission.id,
                    name: permission.name,
                    transportsType: formattedTransportTypes
                  };
                });
              
                return formattedPermissions;
              };
              
              const filteredPermissions = res["permissions"].filter((permission) => permission.status === true);
              const formattedPermissions = formatPermissions(filteredPermissions);
              const newValue = {
                roleName: res["name"],
                description: res["description"],
                permissions: formattedPermissions
              };
              
              setInitValue(newValue);
              


            
            setLoading(false)
            setInitValue(newValue)
            setTypeAction(typeAction)
            const conjunto = [];
            for (let i = 0; i < filteredPermissions.length; i++) {
                toggleSelection(filteredPermissions[i].id);
                for (let j = 0; j < filteredPermissions[i].permissions.length; j++) {
                    if (filteredPermissions[i].permissions[j].status) {
                        const permissionId = filteredPermissions[i].permissions[j].id;
                        for (let k = 0; k < filteredPermissions[i].permissions[j].permissions.length; k++) {
                            if (filteredPermissions[i].permissions[j].permissions[k].status) {
                                conjunto.push({ permissionId, associatedId: filteredPermissions[i].permissions[j].permissions[k].id });
                            }
                        }
                    }
                }
            }
            
            
            toggleSelectionAllTView(conjunto)
            
        } catch (error) {
            console.log("error in update Organization", error)
        }
    }

    useEffect(() => {
        (async () => {
            await getPermissions();
        })();
    }, []);

    useImperativeHandle(ref, () => ({
        detailRole
    }))

    const onClose = () => {
        setTypeAction(initialState)
        setInitValue({
            roleName: "",
            description: "",
            permissions: []
        })
        setDataAccess(initDataAccess)
        setTransportT(initTransportT)
        restProps.onHide() 
    }

    return (
        <Modal
            {...restProps}
            onHide={() => { onClose() }}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={style.todisModalContainer}
            dialogClassName={style.sizeModal70}
        >
            <Modal.Header closeButton className={style.modalHeader}>
                <Modal.Title id="contained-modal-title-vcenter" className={style.modalTitle}>
                    <BsCalendarMinusFill className="me-3" />{titleFormRole} Role
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid className="todis-form-wrapper p-3" style={{height: "770px"}}>
                {   
                !loading ?
                    <Row>
                        <Formik
                            enableReinitialize={true}
                            initialValues={initValue}
                            validationSchema={TODIS_ROLES}
                            onSubmit={typeAction == "create" ? onCreate : onUpdate}>
                            {({ errors, touched, setFieldValue, values }) => (
                                <Form className="todis-form-content p-0">
                                    <Container>
                                        <Row>
                                            <Col lg={6}>
                                                <TODIS_FORM_FIELD id="roleName" label="ROLE NAME" name="roleName" disabled={typeAction == "view"}/>
                                                {errors.roleName && touched.roleName ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.roleName}</div>) : null}
                                            </Col>
                                            <Col lg={12}>
                                                <TODIS_FORM_DSC id="description" label="DESCRIPTION" name="description" style={{height: "80px"}} disabled={typeAction == "view"}/>
                                                {errors.description && touched.description ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.description}</div>) : null}
                                            </Col>
                                            <Col lg={6} className="pb-3">
                                                <span style={{fontWeight: 700, fontSize: "18px"}}><MdLock size={30} className="pe-2" color="#ffc61c"/>Role Permissions</span>
                                            </Col>
                                            <Col lg={3} className="pb-3">
                                                <span style={{fontWeight: 700, fontSize: "18px"}}><FaBus size={30} className="pe-2" color="#ffc61c"/>Transport Modes</span>
                                            </Col>
                                            <Col lg={4}>
                                                <TODIS_FORM_LIST id="dataAccess" type="select" label="DATA ACCESS" items={dataAccess} toggleSelectionAll={toggleSelection} selectAll={selectAll} disabled={typeAction == "view"}/>
                                                {typeAction != "view" && <Button variant="primary" className="todis-submit-btn ter_styles" style={{margin: "0.5rem"}} onClick={() => applyAccessInfo(values, setFieldValue)}><BsPlusLg className="me-3"/>APPLY ACCESS</Button>}
                                            </Col>
                                            <Col lg={8}>
                                                <TODIS_FORM_LIST id="transP" type="select" label="TRANSPORT TYPE" items={transportT.filter(item => item.id != 0)} toggleSelectionAll={toggleSelectionT} selectAll={selectAllT} disabled={typeAction == "view"}/>
                                            </Col>
                                            <Col lg={{ span: 12, offset: 6 }}>
                                                <span style={{ fontWeight: 700, fontSize: "18px" }}><FaMapMarkerAlt size={30} className="pe-2" color="#ffc61c" />Modules</span>
                                            </Col>
                                            <Col lg={{ span: 8, offset: 4 }}>
                                                <TODIS_FORM_LIST_EUAcquis id="transP" type="select" label="MODULES" items={transportT.filter(item => item.id === 0)} toggleSelectionAll={toggleSelectionT} disabled={typeAction === "view"}/>
                                            </Col>

                                            {
                                                values.permissions.length > 0 && typeAction != "view" &&
                                                    <Col lg={12} className="ps-4">
                                                        <Button variant="outline-primary" className={`${style.borderButton} ${"font-monospace fw-bold float-end me-0"}`} onClick={() => {setFieldValue("permissions", []);} }><MdDelete size={18} className="me-2"/>CLEAR ALL</Button>
                                                    </Col>
                                            }
                                            <Col lg={12} className="ps-4">
                                                {errors.permissions && touched.permissions ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.permissions}</div>) : null}
                                                {   values.permissions.length > 0 &&
                                                        <Container  className="todis-form-wrapperR py-2">
                                                        <Row className="float-start" style={{maxHeight: "200px", overflowX: "auto"}}>
                                                                {
                                                                    values.permissions.map((item, index) => <Col lg={2} style={{ width: 'auto' }} key={"access-" + index}>
                                                                                    <h6 style={{fontSize: "13px"}}>
                                                                                        {item.name} : 
                                                                                        {
                                                                                            item.transportsType.map(transport => {
                                                                                                return transport.permissions.map((permission, index) => {
                                                                                                    return <Badge className={style.bgFilter} key={"badge-" + index}><span disabled={typeAction == "view"} className={typeAction != "view" && style.cursorPointer} onClick={() => {typeAction != "view" && removeFilter(values, item.id, transport.id, permission.id, setFieldValue)}}><BsX fontSize={16} color="#3e84b8"/></span> {transport.name} - {permission.name}</Badge>
                                                                                                })
                                                                                            })
                                                                                        }
                                                                                    </h6>
                                                                                </Col>
                                                                    )
                                                                }
                                                            </Row>
                                                        </Container>
                                                }
                                            </Col>
                                            <div className="todis-action-form">
                                                <Button variant="outline-danger" onClick={() => onClose()} className={style.todisBtnOutline}>DISCARD </Button>
                                                {
                                                typeAction == "create" || typeAction == "update" ?
                                                    <Button variant="primary" className="todis-submit-btn bck-btn-secundary" type="submit" style={{margin: "0.5rem", textTransform: "uppercase"}}>{typeAction == "create" && <BsPlusLg className="me-3" />}{titleFormRole} ROLE </Button>
                                                    : null
                                                }
                                            </div>
                                        </Row>
                                    </Container>
                                </Form>
                            )}
                        </Formik>
                    </Row>
                :
                    <LOADING/>
                }
                </Container>
            </Modal.Body>
        </Modal>
    )
});

export { MODAL_ROLE };